
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promocoes/selecao/doubleeleven",
      function () {
        return require("private-next-pages/promocoes/selecao/doubleeleven.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promocoes/selecao/doubleeleven"])
      });
    }
  